import React, { useCallback, useRef, useState } from 'react';

interface Pop { id: number; text: string; x: number; y: number; color: string }

// Floating "+10" style labels that rise and fade where something was scored.
// x and y are percentages of the (position: relative) container they render in.
export function useScorePops() {
  const [pops, setPops] = useState<Pop[]>([]);
  const nextId = useRef(1);
  const pop = useCallback((text: string, x = 50, y = 40, color = '#f59e0b') => {
    const id = nextId.current++;
    setPops(p => [...p, { id, text, x, y, color }]);
    setTimeout(() => setPops(p => p.filter(q => q.id !== id)), 900);
  }, []);
  return { pops, pop };
}

export const ScorePops: React.FC<{ pops: Pop[] }> = ({ pops }) => (
  <>
    {pops.map(p => (
      <span key={p.id} className="fun-rise absolute z-20 pointer-events-none font-black text-2xl whitespace-nowrap"
        style={{ left: `${p.x}%`, top: `${p.y}%`, color: p.color, textShadow: '0 2px 0 #fff, 0 0 10px rgba(255,255,255,0.8)' }}
        aria-hidden="true">
        {p.text}
      </span>
    ))}
  </>
);
